import type { ServiceBlockCategory } from "@modes0/ui-components";
import { createElement } from "react";
import { Globe2, Target } from "lucide-react";

export const GENERAL_SERVICE_TERM_1 = "SEO and Lead Generation";
export const GENERAL_SERVICE_TERM_2 = "Websites";
export const GENERAL_SERVICE_TERM_3 = "Digital Marketing Services";

const serviceBlockAccentColor = "#2eaa2d";
const serviceBlockAccentSoftColor = "#ffffff";
const serviceBlockAccentDarkColor = "#166534";

export const serviceBlockData: ServiceBlockCategory[] = [
    {
        title: "Website Design, SEO & Digital Presence",
        services: [
            "Fast website design in Sydney that looks professional on mobile and desktop.",
            "SEO optimised website development so Google can understand your services.",
            "Landing pages built to turn website visitors into calls, forms and booked leads.",
            "Google Business Profile setup for local search and Google Maps visibility.",
            "Website hosting, domain setup and tracking handled without technical stress.",
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-1.jpg",
        icon: createElement(Globe2, { "aria-hidden": true, strokeWidth: 2.25 }),
        accentColor: serviceBlockAccentColor,
        accentSoftColor: serviceBlockAccentSoftColor,
        accentDarkColor: serviceBlockAccentDarkColor,
    },
    {
        title: "Digital Marketing & Lead Generation",
        services: [
            "Local SEO services that help nearby Sydney customers find your business.",
            "Google Ads campaigns focused on calls, enquiries and real customer leads.",
            "Social media marketing setup with simple content your audience can understand.",
            "Lead generation funnels, forms and follow-up automation to reduce missed enquiries.",
            "Analytics and conversion tracking so you can see which marketing is working.",
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-2.jpg",
        icon: createElement(Target, { "aria-hidden": true, strokeWidth: 2.25 }),
        accentColor: serviceBlockAccentColor,
        accentSoftColor: serviceBlockAccentSoftColor,
        accentDarkColor: serviceBlockAccentDarkColor,
    },
];
